import useSearchDropdown, { getSearchDropdownItems, SearchDropdownItem } from './useSearchDropdown';
import { getDisplayNames } from '../api/utils';
import { Author } from '../api/types/author';
import { PriceTier } from '../api/types/priceTier';
import { TAGS } from '../api/types/others';

type CustomType =
  | 'author'
  | 'priceTier'
  | 'accessType'
  | 'pillarType'
  | 'pillarExpertise'
  | 'lessonType'
  | 'contentGroupType'
  | 'tag';

const getCustomDisplayName = (value: string, type?: CustomType, extraData?: Author[] | PriceTier[]) => {
  switch (type) {
    case 'author':
      return getDisplayNames.author(value, extraData as Author[]) || '';
    case 'priceTier':
      return getDisplayNames.priceTier(value, extraData as PriceTier[]) || '';
    case 'accessType':
      return getDisplayNames.accessType(value) || '';
    case 'pillarType':
      return getDisplayNames.pillarType(value) || '';
    case 'pillarExpertise':
      return getDisplayNames.pillarExpertise(value) || '';
    case 'lessonType':
      return getDisplayNames.lessonType(value) || '';
    case 'contentGroupType':
      return getDisplayNames.contentGroupType(value) || '';
    case 'tag':
      return TAGS.filter((item) => item.value === value)[0].text;
    default:
      return value;
  }
};

const useCustomizedDropdown = ({
  possibleValues,
  singleSelect,
  customType,
  authors,
  priceTiers,
}: {
  possibleValues: Array<string>;
  singleSelect?: boolean;
  customType?: CustomType;
  authors?: Author[];
  priceTiers?: PriceTier[];
}) => {
  const _extraData = customType === 'author' ? authors : customType === 'priceTier' ? priceTiers : undefined;
  const _processLabel = (value: string) => getCustomDisplayName(value, customType, _extraData);
  const _dropdownType = customType === 'author' ? 'authors' : 'basic';
  const _singleSelect = singleSelect || false;

  const props = useSearchDropdown({
    items: getSearchDropdownItems<string>(possibleValues, _processLabel),
    dropdownType: _dropdownType,
    singleSelect: _singleSelect,
  });

  const setProps = (items: string[]) => {
    props.setSelectedItems(() => {
      return items.map((item) => ({
        value: item,
        label: _processLabel(item),
        searchLabel: _processLabel(item)?.toLowerCase(),
      })) as SearchDropdownItem[];
    });
  };

  return { props, setProps };
};
export default useCustomizedDropdown;
